import { MapDirectionsService, MapGeocoder } from "@angular/google-maps";
import { JobDto, UserDto, WageListDto } from "app/api/models";
import { sumList } from "app/app.component";
import { TimeUtil } from "app/core/utils/time-utils";

export class JobUtils {

    public static generateWage(startDate: Date, endDate: Date, driver: UserDto, ref: string, jobId: number) {
        // Rate A - Mon - fri (6am - 6pm)
        // Rate B - Other hours
        console.log("start date, end date", startDate, endDate);

        var totalHours = TimeUtil.getHoursBetween(startDate, endDate);

        console.log("total hours", totalHours);

        var hoursAStart = TimeUtil.setTo1amUTC(new Date(startDate));
        hoursAStart.setHours(6);
        var hoursAEnd = TimeUtil.setTo1amUTC(new Date(startDate));
        hoursAEnd.setHours(18);
        var hoursA = TimeUtil.getHoursOfOverlap(startDate, endDate, hoursAStart, hoursAEnd);
        var hoursB = totalHours - hoursA;

        console.log("hoursAstart, hoursAend", hoursAStart, hoursAEnd);

        var pay = hoursA * driver?.hourlyRateA + hoursB * driver?.hourlyRateB;
        var additions = 0;

        var wage = <WageListDto> {
            dateCreated: new Date().toISOString(),
            driverId: driver.id,
            hoursA: hoursA,
            hoursB: hoursB,
            reference: ref, //'auto-complete-job', //get new number
            fares: pay,
            additions: additions,
            total: pay + additions,
            jobId: jobId,
            // status?: WageStatusDto;
        }

        return wage;
    }

    public static getJobDialogData(isLastJob: boolean) {
        var items: any[] = [
            {name: 'hours', mandatory: true, type: 'number'},
        ]

        if(isLastJob)
            items.push({name: 'Return Location', mandatory: true, propertyName: 'location', locationButton: true });

        return {
            panelClass: 'max-width-item-dialog',
            data: {
                title: "Finish Job",
                items: items,
            }
        };
    }

    public static openLocation(location: string) {
        if(!location) return;

        window.open("http://maps.apple.com/maps?q=" + location); //todo sanitize it??
    }

    
    public static async getGoogleRoute(loc1: string, loc2: string, geocoder: MapGeocoder, directions: MapDirectionsService): Promise<google.maps.DirectionsRoute[]> {
        if(!loc1 || !loc2) return null;

        var res1 = await geocoder.geocode({address: loc1}).toPromise();
        if(!res1.status || !res1.results?.length) return;

        var coords1 = res1.results[0].geometry.location;

        var res2 = await geocoder.geocode({address: loc2}).toPromise();
        if(!res2.status || !res2.results?.length) return;

        var coords2 = res2.results[0].geometry.location;

        var req: google.maps.DirectionsRequest = {
            travelMode: google.maps.TravelMode.DRIVING,
            origin: {
            lat: coords1.lat(),
            lng: coords1.lng(),
            },
            destination: {
            lat: coords2.lat(),
            lng: coords2.lng(),
            },
            provideRouteAlternatives: false,
        };

        console.log("route req", req);

        var res3 = await directions.route(req).toPromise();

        if(!res3.status || !res3.result) return;

        return res3.result.routes;
    }

    public static async calculateDuration(loc1: string, loc2: string, geocoder: MapGeocoder, directions: MapDirectionsService) {
        var routes = await JobUtils.getGoogleRoute(loc1, loc2, geocoder, directions);
        
        var duration = sumList(routes[0].legs.map(x => x.duration.value / 3600)); //seconds to hours

        return duration;
    }

    public static async calculateMileage(loc1: string, loc2: string, geocoder: MapGeocoder, directions: MapDirectionsService) {
        var routes = await JobUtils.getGoogleRoute(loc1, loc2, geocoder, directions);
        
        var distance = sumList(routes[0].legs.map(x => x.distance.value * 0.000621371)); //meters to miles

        return distance;
    }

    public static generateRefuelJobs(job: JobDto): JobDto[] {
        console.log("generating refuels for", job);
        var refuelJobs: JobDto[] = [];

        var jobCopy = Object.assign({}, job);

        jobCopy.jobId = null;
        // jobCopy.collectionAddress = 'Night Refuel';
        jobCopy.deliveryAddress = job.deliveryAddress;
        jobCopy.mileage = 0;
        jobCopy.accepted = false;
        jobCopy.declined = false;
        jobCopy.completed = false;
        jobCopy.requireForm = false;
        jobCopy.isPending = false;
        jobCopy.jobType = 'Refuel';

        var endDate = job.deliveryDate ? new Date(job.deliveryDate) : null;//TimeUtil.addDays(TimeUtil.setTo2359UTC(new Date(job.deliveryDate)), -1);          //11pm night before delivery end
        // var nightRefuelTime = TimeUtil.setTo2359UTC(new Date(job.collectionDate));                      //refuel for first day overnight
        var refuelTime = TimeUtil.addHours(TimeUtil.setTo1amUTC(new Date(job.collectionDate)), 8);    //refuel for morning
        // var pmRefuelTime = TimeUtil.addHours(TimeUtil.setTo1amUTC(new Date(job.collectionDate)), 17);   //refuel for afternoon

        var refuelI = 0;

        //determine if multi day or single day job
        // var multiDay = endDate ? (TimeUtil.getHoursBetween(new Date(job.collectionDate), new Date(job.deliveryDate)) > 12) : false;
        //Any job that starts and end on same day needs to have an auto depot refuel job added (Copied of job but called Depot Refuel)
        // Any job that spans over multiple days - Needs to auto night refuel and day refuel for following day (Jobs)

        refuelTime = TimeUtil.addHours(TimeUtil.setTo1amUTC(new Date(refuelTime)), 7); //8am
        console.log("refuel time", refuelTime);

        if(jobCopy.genId.startsWith('200')) {
            //200 jobs - AM/PM, Night

            //AM refuel
            var amJob = Object.assign({}, jobCopy);
            amJob.collectionAddress = "AM Refuel";
            amJob.jobType = "AM Refuel";
            amJob.collectionDate = refuelTime.toISOString();
            amJob.deliveryDate = refuelTime.toISOString();
            amJob.jobRef = `${job.jobRef}-RF${++refuelI}`;

            refuelJobs.push(amJob);

            refuelTime = TimeUtil.addHours(refuelTime, 8); //4pm

            //PM refuel
            var pmJob = Object.assign({}, jobCopy);
            pmJob.collectionAddress = "PM Refuel";
            pmJob.jobType = "PM Refuel";
            pmJob.collectionDate = refuelTime.toISOString();
            pmJob.deliveryDate = refuelTime.toISOString();
            pmJob.jobRef = `${job.jobRef}-RF${++refuelI}`;

            refuelJobs.push(pmJob);

            //200 Jobs also have a night refuel
            refuelTime = TimeUtil.setTo2359UTC(refuelTime); //11pm

            var nightJob = Object.assign({}, jobCopy);
            nightJob.collectionAddress = "Night Refuel";
            nightJob.jobType = "Night Refuel";
            nightJob.collectionDate = refuelTime.toISOString();
            nightJob.deliveryDate = refuelTime.toISOString();
            nightJob.jobRef = `${job.jobRef}-RF${++refuelI}`;

            refuelJobs.push(nightJob);
        }
        else {
            //NOT 200 jobs - Day, Depot

            //Day refuel
            var dayJob = Object.assign({}, jobCopy);
            dayJob.collectionAddress = "Day Refuel";
            dayJob.jobType = "Day Refuel";
            dayJob.collectionDate = refuelTime.toISOString();
            dayJob.deliveryDate = refuelTime.toISOString();
            dayJob.jobRef = `${job.jobRef}-RF${++refuelI}`;

            refuelJobs.push(dayJob);
            
            if (endDate) {
                //Depot refuel
                var depotJob = Object.assign({}, jobCopy);
                depotJob.collectionAddress = "Depot Refuel";
                depotJob.jobType = "Depot Refuel";
                depotJob.collectionDate = endDate.toISOString();
                depotJob.deliveryDate = endDate.toISOString();
                depotJob.jobRef = `${job.jobRef}-RF${++refuelI}`;

                refuelJobs.push(depotJob);
            }
        }

        return refuelJobs;
    }

}
